import React, { useMemo } from 'react';
import { Tooltip, Whisper } from 'rsuite';
import { BaseCell } from '../../../../../../../components';
import { RuleDataItem } from '../../lib/service';
import { listFormater } from '../../lib/utils';

const renderStoreLabel = ({ storeIds, clusters }: Pick<RuleDataItem, 'storeIds' | 'clusters'>): string => {
  if (clusters?.length) {
    return listFormater.format(clusters.map(({ label }) => label));
  }
  if (storeIds?.length) {
    return listFormater.format(storeIds);
  }
  return 'Todas as lojas';
};

const renderStoreCount = ({ storeIds, clusters }: Pick<RuleDataItem, 'storeIds' | 'clusters'>): string => {
  if (clusters?.length) {
    return clusters.length > 1 ? `${clusters.length} clusters` : `${clusters.length} cluster`;
  }
  if (storeIds?.length) {
    return storeIds.length > 1 ? `${storeIds.length} lojas` : `${storeIds.length} loja`;
  }
  return '';
};

const RulePageTableStoreCell = ({ storeIds = [], clusters = [] }: RuleDataItem) => {
  const storeLabel = useMemo(() => renderStoreLabel({ storeIds, clusters }), [storeIds, clusters]);

  return (
    <BaseCell>
      <Whisper speaker={<Tooltip>{storeLabel}</Tooltip>}>
        <BaseCell.MainContainer>
          <p className="truncate">{storeLabel}</p>
        </BaseCell.MainContainer>
      </Whisper>

      {(!!storeIds?.length || !!clusters?.length) && <BaseCell.SubContainer>{renderStoreCount({ storeIds, clusters })}</BaseCell.SubContainer>}
    </BaseCell>
  );
};

export default RulePageTableStoreCell;
